<template id="question-fare-setup">
    <li>
        <!-- <div class="info">question-fare-setup</div> -->
        <div v-html="question" class="question"></div>
        <div>
            <button :data-automation="trackingclass+'-yes'" :class="[ value==1 ? 'active' : '' ]"
                @click="updateValue( index, 1 )" class="large">
                <div>
                    <div class="col-xs-12">
                        <span class="icon icon-monoraria"></span>
                        MONORARIA
                    </div>
                </div>
                <div class="details">
                    <div class="col-xs-12">
                        <strong>LUCE</strong> 24h<br>tutti i giorni
                    </div>
                </div>
            </button>
            <button :data-automation="trackingclass+'-no'" :class="[ value==0 ? 'active' : '' ]"
                @click="updateValue( index, 0 )" class="large">
                <div>
                    <div class="col-xs-12">
                        <span class="icon icon-bioraria-sx"></span>+<span class="icon icon-bioraria-dx"></span>
                        BIORARIA
                    </div>
                </div>
                <div class="details">
                    <div class="col-xs-6 no-padding-right">
                        <strong>LUCE F1</strong> 08:00 - 19:00<br>lun-ven escluse festività
                    </div>
                    <div class="col-xs-6 no-padding-left">
                        <strong>LUCE F2</strong> 19:00 - 08:00<br>week-end e festività
                    </div>
                </div>
            </button>
        </div>
    </li>
</template>

<script>
export default {
    template: '#question-fare-setup',

    props: ['question', 'index', 'trackingclass'],
    data: function () {
        return {
            value: -1
        };
    },

    created: function () {
        this.value = -1;
    },
    beforeMount: function () {
        this.value = -1;
    },
    methods: {
        updateValue: function (index, val) {
            console.log('updateValue', index, val);
            this.value = val;

            switch (val) {
                case 0:
                    this.fare = "bioraria";
                  break;
                case 1:
                    this.fare = "monoraria";
                break;
              } 

            console.log('this.value mono/bi ----> ', this.fare);
            this.$emit('update-fare-setup', this.fare);
            this.$emit('update-value', [index, val]);
        }
    }
}
</script>
